import React, { Fragment, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { node, string } from "prop-types";
import ContentFeature from "Components/ContentFeature";
import ReadMoreText from "Components/ReadMoreText";
import { FaDownload, FaRegMinusSquare, FaRegPlusSquare } from "react-icons/fa";
import { venueInteraction } from "../../modules/analytics";
import { isAgency, isCorporate, isRolePlatformAdmin, isVenue, venues } from "../../modules/auth";
import { getYouTubeEmbedUrl, getYouTubeThumbnailUrl } from "../../utils";
import { ButtonBrand } from "../../Components/Button";
import axios from "axios";
import * as VENUE_ROUTES from "../../Router/venue_routes";
import { useOnScreen } from "../../hooks/useOnScreen";
import { VENUE_TAGS } from "../../modules/analytics/tags";
import { isCompanyAdmin, isCompanyUser } from "../../modules/permissions";
import YoutubeModal from "./YoutubeModal";
import './aboutBrandYoutubeButton.css'


const AboutTheBrand = ({
                         anchor,
                         mobile,
                         venueSlug,
                         hotelGroupDescription,
                         venueInteraction,
                         isAgency,
                         isCorporate,
                         isRolePlatformAdmin,
                         venue,
                         venueId,
                         dataScore,
                         impressionId,
                          isVenue,
                          venues,
                         setBrandLogo = () => {
                         },
                       }) => {
  const [expanded, setExpanded] = useState(false);
  const [brandData, setBrandData] = useState();
  const [loading, setLoading] = useState(true);
  const hasBeenOnScreenRef = useRef(false);
  const [showYoutubeModal, setShowYoutubeModal] = useState()
  const aboutBrandRef = useRef();
  const onScreen = useOnScreen(aboutBrandRef, "0px");
  let hasVenue = isVenue && venues && venueId ? venues.map(venue => venue.id).includes(venueId) : false;
  useEffect(() => {
    if (onScreen && !hasBeenOnScreenRef.current) {
      hasBeenOnScreenRef.current = true;
     venueInteraction({
        type: VENUE_TAGS.VENUE_GROUP_CONTENT_VIEWED,
        data_score: dataScore,
        impression_id: impressionId,
        id:venueId,
      });
    }
  }, [onScreen]);
  useEffect(() => {
    const fetchBrandData = async () => {
      if (!venueSlug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const apiUrl = window.API + VENUE_ROUTES.API.VENUE.BRAND.replace(":venue", venueSlug);
        const response = await axios.get(apiUrl);

        setBrandData(response.data.data);
        if (setBrandLogo) {

          setBrandLogo(response?.data?.data?.cdn_path ? `${process.env.REACT_APP_API}/api/hotel-groups/${response?.data?.data?.id}/image` : null);
        }
      } catch (err) {
        console.error("Failed to fetch brand data:", err);
        setBrandData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBrandData();
  }, [venueSlug]);

  const brandDescription = brandData?.brand_description || hotelGroupDescription || "";

  let agencyProfile = null;
  let hotelBrandVideo = null;
  let hotelBrandVideoCorporate = null;
  let agentDownloadDocument = null;
  let accountManagerUpdate = null;

  if (isAgency || isRolePlatformAdmin || isCorporate || hasVenue) {
    agencyProfile = brandData?.agency_profile;
    hotelBrandVideo = brandData?.account_manager_video;
    hotelBrandVideoCorporate = brandData?.account_manager_video_corporate;
    accountManagerUpdate = brandData?.account_manager_update;
    agentDownloadDocument = brandData?.agency_download_cdn_path;
  }

  const toggle = () => {
    setExpanded(!expanded);
  };

  if (!brandDescription && !agencyProfile && (!hotelBrandVideo || !hotelBrandVideoCorporate)) return null;
  return (
    <Fragment>
      <div ref={aboutBrandRef}>
         <span className="anchor sr-only" id={anchor}>
        About the Group
      </span>
        {brandData?.brand_description && brandData.brand_description !== hotelGroupDescription && (
          <section className="bg-white text-lg mb-3 shadow">
            <h2
              className={`pt-4 px-3 text-xl ${mobile &&
              "border-b border-light-blue-grey flex items-center justify-between pb-2"}`}
              onClick={toggle}
            >
              About {venue?.hotel_group?.name || ""}
              {mobile && !expanded && <FaRegPlusSquare className="text-base" />}
              {mobile && expanded && <FaRegMinusSquare className="text-base" />}
            </h2>
            {(!mobile || (mobile && expanded)) && (
              <div className="row">
                <div className="col col-w-full">
                  {brandDescription && (
                    <ContentFeature classes="col px-3 mb-3">
                      <ReadMoreText maxLength={500}>{hotelGroupDescription}</ReadMoreText>
                    </ContentFeature>
                  )}
                </div>
              </div>
            )}
          </section>
        )}


        <section className="bg-white text-lg mb-3 shadow">



          {(!mobile || (mobile && expanded)) && (
            <div className="row">
              <div className="col col-w-full">
                <div className={'flex justify-between'}>
                  <div>
                    <h2
                      className={`pt-4 px-3 text-xl ${mobile &&
                      "mb-3 py-4 px-3 text-xl border-b border-light-blue-grey flex items-center justify-between"}`}
                      onClick={toggle}
                    >
                      About {brandData?.name || ""}
                      {mobile && !expanded && <FaRegPlusSquare className="text-base" />}
                      {mobile && expanded && <FaRegMinusSquare className="text-base" />}
                    </h2>
                    {brandDescription && (
                      <ContentFeature classes="col px-3 mb-3">
                        <ReadMoreText maxLength={500}>{brandDescription}</ReadMoreText>
                      </ContentFeature>
                    )}

                  </div>
                  {brandData && brandData.cdn_path ?
                    <div className="bg-white px-4 mr-2 mt-2 ">
                      <img
                        src={`${process.env.REACT_APP_API}/api/hotel-groups/${brandData.id}/image`}
                        style={{
                          maxWidth: 72,
                          maxHeight: 72,
                        }}
                      />
                    </div>
                    : null}
                </div>

                {agencyProfile  && (isAgency || isRolePlatformAdmin ||hasVenue) ? (
                  <div>
                    <ContentFeature
                      title="Agent Information"
                      classes="px-3 mb-3"
                    >
                      <ReadMoreText>{agencyProfile}</ReadMoreText>
                    </ContentFeature>
                  </div>
                ) : null}


                {agentDownloadDocument && (isAgency || isRolePlatformAdmin || hasVenue) ? (
                  <div className="px-3 mb-3">
                    <a
                      href={agentDownloadDocument}
                      download
                      target={"_blank"}
                      rel={"noreferrer noopener"}
                      className="inline-flex items-center py-2 text-sm font-medium transition-colors duration-200"
                    >
                      <ButtonBrand outlined={true} onClick={() => {
                        venueInteraction({
                          type: VENUE_TAGS.VENUE_DOWNLOAD_GROUP_AGENCY_DOCUMENT,
                          data_score: dataScore,
                          impression_id: impressionId,
                          id:venueId,
                        });
                      }}>
                        <FaDownload className="mr-2" />
                        Download Document
                      </ButtonBrand>
                    </a>
                  </div>
                ) : null}

                {accountManagerUpdate  && (isAgency || isRolePlatformAdmin || hasVenue || isCorporate)  ? (
                  <div className="">
                    <ContentFeature
                      title="Account Manager Update"
                      classes="px-3 mb-3"
                    >
                      <ReadMoreText>{accountManagerUpdate}</ReadMoreText>
                    </ContentFeature>
                  </div>
                ) : null}
                <div className={'row px-3 mb-3'}>
                  {hotelBrandVideo && (isAgency || isRolePlatformAdmin || hasVenue) ?  (
                    <div className="col md:col-w-1/2">
                      {isRolePlatformAdmin || hasVenue ? <p>Agency Video</p> : ''}
                      <div className="relative w-full mb-4 video-thumbnail"
                           style={{ paddingBottom: "56.25%" }}
                           onClick={() => {
                             venueInteraction({
                               type: VENUE_TAGS.VIEW_HOTEL_GROUP_VIDEO,
                               data_score: dataScore,
                               impression_id: impressionId,
                               id: venueId,
                             });
                             setShowYoutubeModal('nonCorporate')
                           }}>
                        <img   className="absolute pin w-full h-full"
                               id="ytplayer"
                               src={getYouTubeThumbnailUrl(hotelBrandVideo)} />
                        <div className="play-btn">
                          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <polygon points="5,3 19,12 5,21"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {hotelBrandVideo && (isCorporate || isRolePlatformAdmin || hasVenue) ? (
                    <div className="col md:col-w-1/2">
                      {isRolePlatformAdmin || hasVenue ? <p>Corporate Video</p> : ""}
                      <div className="relative w-full mb-4 video-thumbnail"
                           style={{ paddingBottom: "56.25%" }}
                           onClick={() => {
                             venueInteraction({
                               type: VENUE_TAGS.VIEW_HOTEL_GROUP_VIDEO_CORPORATE,
                               data_score: dataScore,
                               impression_id: impressionId,
                               id: venueId,
                             });
                              setShowYoutubeModal('corporate')
                           }}>

                            <img   className="absolute pin w-full h-full"
                                   id="ytplayer"
                                   src={getYouTubeThumbnailUrl(hotelBrandVideoCorporate)} />
                            <div className="play-btn">
                              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <polygon points="5,3 19,12 5,21"/>
                              </svg>
                            </div>
                        </div>
                    </div>
                  ) : null}
                  {showYoutubeModal  ?  <YoutubeModal
                    youtubeUrl={showYoutubeModal === 'corporate' ?  hotelBrandVideoCorporate : hotelBrandVideo}
                    closeModal={() => setShowYoutubeModal(false)}
                  /> : null}

                </div>

              </div>
            </div>
          )}
        </section>
      </div>

    </Fragment>
  );
};

AboutTheBrand.propTypes = {
  anchor: string.isRequired,
  info: node,
  location: node,
  description: node,
};

const mapStateToProps = (state, props) => {
  return {
    isAgency: isAgency(state),
    isCorporate: isCorporate(state) || isCompanyAdmin(state.auth) || isCompanyUser(state.auth),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    isVenue: isVenue(state),
    venues: venues(state)
  };
};

export default connect(mapStateToProps, { venueInteraction })(AboutTheBrand);